import { Injectable, NgZone } from '@angular/core';
import * as RecordRTC from 'recordrtc';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import RecordingsActions from '../reducers/recordings/recordings.actions';
import { AppState } from '../models/appState';
import { takeUntil } from 'rxjs/operators';

var DetectRTC = require('detectrtc')
DetectRTC.load(function() {
  DetectRTC.hasMicrophone; // (has microphone device!)
  DetectRTC.hasSpeakers; // (has speakers!)
  DetectRTC.isAudioContextSupported;
  DetectRTC.isWebRTCSupported;
  DetectRTC.browser.isSafari;
  DetectRTC.osVersion;
  DetectRTC.osName;
  DetectRTC.isMobileDevice;
});

/*
  Recording/Audio service that starts and stops Recordings, and returns
  a Blob object with a title.

*/

/*
  interface that stores the blob object and the title of the recording
*/
interface RecordedAudioOutput {
  blob: Blob;
  title: string;
}

@Injectable({
  providedIn: 'root',
})
export class AudioService {
  private stream;
  private recorder;
  private interval;
  private startTime;
  private _recorded = new Subject<RecordedAudioOutput>();
  private _recordingTime = new Subject<string>();
  private _recordingFailed = new Subject<string>();
  private audioInputLevel = new Subject<string>();
  private soundMeter;
  public soundMeterRefreshInterval;
  private audioContext: AudioContext;
  private recordingCategory: string;

  constructor(private _store: Store<AppState>) {
  }
  /*
    returns the blob object recorded by the user
  */
  getRecordedBlob(): Observable<RecordedAudioOutput> {
    return this._recorded.asObservable();
  }

  /*
    returns the duration of the recording
  */
  getRecordedTime(): Observable<string> {
    return this._recordingTime.asObservable();
  }

  /*
    throws the error message if a recording failed
  */
  recordingFailed(): Observable<string> {
    return this._recordingFailed.asObservable();
  }

  // See source here for this code's inspiration and a github demo:
  // https://github.com/webrtc/samples/blob/gh-pages/src/content/getusermedia/volume/js/main.js
  setupAudioMeter() {
    try {
      // this.audioContext = new AudioContext() || (window as any).webkitAudioContext;
      this.audioContext = new AudioContext();
    } catch (e) {
      alert('Web Audio API not supported.');
    }
    // Instantiate a new soundMeter which evaluates the incoming stream
    this.soundMeter = new SoundMeter(this.audioContext);

    this.soundMeter.connectToSource(this.stream, function (e) {
      if (e) {
        alert(e);
        return;
      }
    });
    // console.log("Before Set Interval")
    // Set the observable's next value to the current metered level every 50ms
    this.soundMeterRefreshInterval = setInterval(() => {
      // console.log("Inside Interval")
      if (this.soundMeter){
        this.audioInputLevel.next(this.soundMeter.slow.toFixed(2));
      }
    }, 50);
  }

  teardownAudioMeter() {
    clearInterval(this.soundMeterRefreshInterval);
    if (this.soundMeter){
      this.soundMeter.stop();
      this.soundMeter = null;
    }
    // this.soundMeterRefreshInterval = null;
  }

  getCurrentAudioLevel() {
    return this.audioInputLevel.asObservable();
  }

  /*
    starts the recording recording by using the
    user media

    @param recordingCategory: This needs to be set so that we generate the filename properly
    failure: Function called if there are any errors
    success: Function called if recording is started successfully.
  */
  startRecording(recordingCategory, failure, success) {
    // Assign this so that we can create the correct filename later
    this.recordingCategory = recordingCategory;
    // navigator.permissions.query({ name: "" }).then(function (result) {
    //   console.log('Audio recording permissions', result);
    //   if (result.state == 'granted') {
    //   } else if (result.state == 'prompt') {
    //   } else if (result.state == 'denied') {
    //   }
    // });
    this._recordingTime.next('00:00');
    navigator.mediaDevices
      .getUserMedia({ video: false, audio: true })
      .then((s) => {
        this.stream = s;//Might have something to do with not recording in ios < 15 error
        this.setupAudioMeter(); //comment this out + audioMeterSubscription in record page
        this.record(); //Might have something to do with not recording in ios < 15 error
        success();
      })
      .catch((error) => {
        failure();
        // console.error(error)
        // console.error('Recording Device Setup Failed')
        this._recordingFailed.next();
      });
  }

  /*
    stops the recording
  */
  cancelRecording() {
    this.stopMedia();
  }

  storeRecording(audioFile) {
    this._store.dispatch(RecordingsActions.storeRecording(audioFile));
  }

  /*
    starts the record() by using the MediaSAtream API by initializing the
    current time, applying constraints and settings, and starting the recorder
  */
  private record() {
    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
               navigator.userAgent &&
               navigator.userAgent.indexOf('CriOS') == -1 &&
               navigator.userAgent.indexOf('FxiOS') == -1;
    // console.log("OS", DetectRTC.osName)
    // if((isSafari && !DetectRTC.isMobileDevice) || ((DetectRTC.osName == "iOS") && (DetectRTC.osVersion < 15) )){ //Add check for not Safari 15 - safari 15 low audio
    //   this.recorder = new RecordRTC.StereoAudioRecorder(this.stream.clone(), {
    //     type: 'mp3',
    //     mimeType: 'audio/mpeg',
    //     sampleRate: 48000,
    //     bufferSize: 4096,
    //   });
    // }
    // else{
    //   this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
    //     type: 'mp3',
    //     mimeType: 'audio/mpeg'
    //   });
    // }
    this.stream.getAudioTracks().forEach((track: any) => {
      track.enabled=true;
      track.applyConstraints({
        volume:0.85,
        echoCancellation: false,
        autoGainControl: false,
        noiseSuppresion: false,
        sampleRate: 44100,
        channelCount:1
      }).then(() => {

        // Not sure how to check that this is good since they both give different values
        // console.log(this.stream.getAudioTracks()[0].getSettings());
        // console.log(this.stream.getAudioTracks()[0].getConstraints());
        console.log("Here is the stream value at like 224, ", this.stream)
        // if((isSafari && !DetectRTC.isMobileDevice) || ((DetectRTC.osName == "iOS") && (DetectRTC.osVersion < 15) )){ //Add check for not Safari 15 - safari 15 low audio
        //   this.recorder = new MediaRecorder(this.stream, {
        //     bitsPerSecond: 128000
        // });
        // }
        // else{
        //   this.recorder = new MediaRecorder(this.stream, {
        //     bitsPerSecond: 128000,
        //     mimeType: 'audio/webm'
        // });
        // }
        this.recorder = new MediaRecorder(this.stream, {
            bitsPerSecond: 128000
        });
        console.log("After the recorder is created")
        this.recorder.start();
        this.startTime = moment();
        this.recorder.addEventListener("dataavailable", (e)=>{ //This is how the audio data is captured; will be called when recording is stopped and send blob to stack for access
          try{
            if(this.startTime){
              var blob = e.data;
              const mp3Name = encodeURIComponent(
                this.recordingCategory + '_' + new Date().getTime() + '.mp3'
              );
              this.stopMedia();
              this._recorded.next({ blob: blob, title: mp3Name });
            }
          }
          catch (e){
            this.stopMedia();
            this._recordingFailed.next();
          }

        }, {once: true});
        this.interval = setInterval(() => {
          const currentTime = moment();
          const diffTime = moment.duration(currentTime.diff(this.startTime));
          const time =
            this.toString(diffTime.minutes()) +
            ':' +
            this.toString(diffTime.seconds());
          this._recordingTime.next(time);
        }, 1000);
      })
      .catch(e => {
        // The constraints could not be satisfied by the available devices.
        // In that case, we continue without it
        // As of Thursday, nothing happened if the constraints weren't met correctly. It just continues to record as normal
        // this.stopMedia();
        // this._recordingFailed.next();
      });
    });
  }

  /*
    turns the Blob object to the string
  */
  private toString(value) {
    let val = value;
    if (!value) {
      val = '00';
    }
    if (value < 10) {
      val = '0' + value;
    }
    return val;
  }

  /*
    stops the recording process
  */
  stopRecording() {
    if (this.recorder) {
    //   // console.log("Buffer Size", this.recorder)
    //   // console.log("Sample rate", this.recorder.sampleRate)
    //   // console.log(this.recorder.blob);
    try{
      this.soundMeter.stop();
      this.recorder.stop();
    } catch {
      this.stopMedia();
      this._recordingFailed.next();
    }
    }
  }

  /*
   stops the media within the stopRecording() method
   resets timer
  */
  private stopMedia() {
    if (this.recorder) {
      this.recorder = null;
      clearInterval(this.interval);
      this.startTime = null;
      if (this.stream) {
        this.stream.getAudioTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    }
  }
}

/*
 *  V SoundMeter Code from WebRTC
 *  Copyright (c) 2015 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

/*
  This is used to generate the values for the audio wave in the record page
*/
function SoundMeter(context) {
  this.context = context;
  this.instant = 0.0;
  this.slow = 0.0;
  this.clip = 0.0;
  this.script = context.createScriptProcessor(2048, 1, 1);
  const that = this;
  this.script.onaudioprocess = function (event) {
    const input = event.inputBuffer.getChannelData(0);
    let i;
    let sum = 0.0;
    let clipcount = 0;
    for (i = 0; i < input.length; ++i) {
      sum += input[i] * input[i];
      if (Math.abs(input[i]) > 0.99) {
        clipcount += 1;
      }
    }
    that.instant = Math.sqrt(sum / input.length);
    that.slow = 0.85 * that.slow + 0.15 * that.instant;
    that.clip = clipcount / input.length;
  };
}
SoundMeter.prototype.connectToSource = function (stream, callback) {
  // console.log('SoundMeter connecting');
  try {
    this.mic = this.context.createMediaStreamSource(stream);
    this.mic.connect(this.script);
    // necessary to make sample run, but should not be.
    this.script.connect(this.context.destination);
    if (typeof callback !== 'undefined') {
      callback(null);
    }
  } catch (e) {
    // console.error(e);
    if (typeof callback !== 'undefined') {
      callback(e);
    }
  }
};
SoundMeter.prototype.stop = function () {
  // console.log('SoundMeter stopping');
  this.mic.disconnect();
  this.script.disconnect();
};
